import { render, staticRenderFns } from "./Modal_txn.vue?vue&type=template&id=ff1c48e8&"
import script from "./Modal_txn.vue?vue&type=script&lang=js&"
export * from "./Modal_txn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports